import close from '../../assets/images/close.png';
import styles from './ViewDescriptionModal.module.css';
import Button from '../Button.jsx';

const ViewDescriptionModal = (props) => {
    return (
        <div className={styles.modal}>
            <div className={styles.container}>
                <img className={styles.close} src={close} alt="Close" onClick={props.close}/>
                <div className={styles.description}>
                    {props.description}
                </div>
                <Button className={styles.button} text="Close" onClick={props.close}/>
            </div>
        </div>
    )
};

export default ViewDescriptionModal;